import React from "react";
import styles from "./CtaButton.module.css";

interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  target?: string;
  rel?: string;
  className?: string;
}

export const CtaButton: React.FC<CtaButtonProps> = ({
  href,
  children,
  target,
  rel,
  className,
}) => (
  <a
    href={href}
    target={target}
    rel={rel}
    className={`${styles.ctaButton} ${className ?? ""}`}
  >
    {children}
  </a>
);
